export default "__VITE_ASSET__vcoq6UBA__"